import { useEffect, useState } from 'react';

import { ILocalizedMenuEntry } from 'state/unified-menu/types';

import { NUM_COLUMNS } from './styled';

type SelectedRow = {
  itemId: string;
  rowIndex: number;
} | null;

interface IUseSelectedGridRowParams<T extends { id: string }> {
  items: T[];
  selectedItemId?: string;
}

export const useSelectedGridRow = <T extends { id: string }>({
  items,
  selectedItemId,
}: IUseSelectedGridRowParams<T>) => {
  const [selectedRow, setSelectedRow] = useState<SelectedRow>(null);

  useEffect(() => {
    if (!selectedItemId) {
      setSelectedRow(null);
      return;
    }

    const index = items.findIndex(item => item.id === selectedItemId);

    if (index === -1) {
      setSelectedRow(null);
      return;
    }

    setSelectedRow({
      itemId: selectedItemId,
      rowIndex: Math.floor(index / NUM_COLUMNS),
    });
  }, [items, selectedItemId]);

  const handleItemPress = (item: ILocalizedMenuEntry, rowIndex: number) => {
    if (item.options?.entries?.length) {
      setSelectedRow({ itemId: item.id, rowIndex });
    } else {
      setSelectedRow(null);
    }
  };

  return {
    selectedRow,
    setSelectedRow,
    handleItemPress,
  };
};
